import React from 'react'
import Footer from './footer.componets'
import Instagram from './instagram.componets'

export const Favourite = () => {
  return (
    <>
    <section class="shop-cart spad">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="shop__cart__table">
                    <table>
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Price</th>
                                <th>Status</th>
                                <th>Action</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            {/* style={{
                background: "#ffffff  url(assets/img/shop-cart/cp-1.jpg) no-repeat left top",
                
              }} */}
                                <td class="cart__product__item">
                                    <img src="assets/img/shop-cart/cp-1.jpg" alt=""/>
                                    <div class="cart__product__item__title">
                                        <h6>Chain bucket bag</h6>
                                        <div class="rating">
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                        </div>
                                    </div>
                                </td>
                                <td class="cart__price">$ 150.0</td>
                                <td class="cart__quantity">
                                    <div class="pro-qty">
                                        <span>in stock</span>
                                    </div>
                                </td>
                                <td class="cart__total"> <button type="submit" class="site-btn"> <span className="icon_bag_alt"></span></button></td>
                                <td class="cart__close"><span class="icon_close"></span></td>
                            </tr>
                            <tr>
                                <td class="cart__product__item">
                                    <img src="assets/img/shop-cart/cp-2.jpg" alt=""/>
                                    <div class="cart__product__item__title">
                                        <h6>Zip-pockets pebbled tote briefcase</h6>
                                        <div class="rating">
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                        </div>
                                    </div>
                                </td>
                                <td class="cart__price">$ 170.0</td>
                                <td class="cart__quantity">
                                    <div class="pro-qty">
                                        <span>in stock</span>
                                    </div>
                                </td>
                                <td class="cart__total"> <button type="submit" class="site-btn"> <span className="icon_bag_alt"></span></button></td>
                                <td class="cart__close"><span class="icon_close"></span></td>
                            </tr>
                            <tr>
                                <td class="cart__product__item">
                                    <img src="assets/img/shop-cart/cp-3.jpg" alt=""/>
                                    <div class="cart__product__item__title">
                                        <h6>Black jean</h6>
                                        <div class="rating">
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                        </div>
                                    </div>
                                </td>
                                <td class="cart__price">$ 85.0</td>
                                <td class="cart__quantity">
                                    <div class="pro-qty">
                                        <span>in stock</span>
                                    </div>
                                </td>
                                <td class="cart__total"> <button type="submit" class="site-btn"> <span className="icon_bag_alt"></span></button></td>
                                <td class="cart__close"><span class="icon_close"></span></td>
                            </tr>
                            <tr>
                                <td class="cart__product__item">
                                    <img src="assets/img/shop-cart/cp-4.jpg" alt=""/>
                                    <div class="cart__product__item__title">
                                        <h6>Cotton Shirt</h6>
                                        <div class="rating">
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                        </div>
                                    </div>
                                </td>
                                <td class="cart__price">$ 55.0</td>
                                <td class="cart__quantity">
                                    <div class="pro-qty">
                                        <span>in stock</span>
                                    </div>
                                </td>
                                <td class="cart__total"> <button type="submit" class="site-btn"> <span className="icon_bag_alt"></span></button></td>
                                <td class="cart__close"><span class="icon_close"></span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
       
    </div>
</section>
<Instagram />
 <Footer/>
</>
  )
}
